module.exports = __webpack_public_path__ + "static/media/home_banner.4bcb5a7e.webp";